import React from 'react'
import PropTypes from 'prop-types'

function TableWithHeaderWrap (props) {
  return (
    <div className='styled-table flex flex-col'>
      <div className='-my-2 sm:-mx-6 lg:-mx-8'>
        <div className='py-2 align-middle inline-block w-full sm:px-6 lg:px-8'>
          <div className='shadow-lg overflow-hidden border-b border-gray-200 rounded-lg bg-white'>
            {props.children}
          </div>
        </div>
      </div>
    </div>
  )
}

export default TableWithHeaderWrap
